import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   

    getRolesMenuIndex(state,value){
        
        
       
        post(urls.admin.roles_menu.index,value).then((result)=>{
          
          
          
          state.result=result


        
       
        
       
           
        });
        
    },


    addRolesMenu(state,value){
        
        

        post(urls.admin.roles_menu.add,value).then((result)=>{
          

          
          state.result=result
        
       
        
       
           
        });
        
    },


    
   

    

}
const  actions={


    getRolesMenuIndexAction(context,value){
       
        context.commit("getRolesMenuIndex",value)
       
    },
  
    addRolesMenuAction(context,value){
       
        context.commit("addRolesMenu",value)
       
    },


    
    

}

export default {state,mutations,actions}